import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  paper: {
    padding: '50px'
  },
  fullWidth: {
    boxShadow: '0px 1px 14px 0px rgba(0,0,0,0.34)',
    zIndex: 1,
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    height: '200px',
    display: 'flex'
  }
}));

const OperatingMetrics = (props) => {
  const classes = useStyles();

  return (
    <div style={{ flexGrow: 1 }}>
      <Grid container justify="center" spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.fullWidth}>
            <Grid item xs={10}>
              <Grid
                alignItems="flex-start"
                container
                direction="row"
                justify="space-between">
                <Typography color="initial" variant="h2">
                  Operating Metrics
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default withRouter(OperatingMetrics);
